<article class="tw-box-approval">
  <div class="tw-box-approval__action">
  <!-- HEADER -->
  <div class="tw-box-approval__header">
      <div class="tw-box-approval__version">
          <span class="tw-box-approval__txt">Your <strong>approval</strong> is required on artwork {{version.version}} of</span>
      </div>
      <core-labels-list [labels]="version.labels"></core-labels-list>
  </div>
  <!-- END HEADER -->
  <!-- BODY -->
  <div class="tw-box-approval__body clearfix">
      <div class="preview" *ngIf="files.length > 0">
          <a href="javascript:void(0)" (click)="toggleShow()" class="tw-box-approval__fig">
              <core-preview-first [files]="files" [format]="'small-width'"></core-preview-first>
          </a>
          <div class="tw-box-approval__ctn">
          <form >
              <textarea placeholder="Start typing your message…" [formControl]="valueText" required></textarea>
          </form>
          <div class="tw-box-approval__ctn  tw-box-approval__ctn--previews" *ngIf="showFilesList">
              <core-files-list-download [files]="files" (onClick)="fileClick($event)"></core-files-list-download>
          </div>
        </div>
      </div>
  </div>
  <div class="tw-box-approval__fieldset">
      <core-helpers-forms-button [disabled]="disabled" [text]="'Approve'" (submit)="action(true)"></core-helpers-forms-button>
      <core-helpers-forms-button [disabled]="disabled" [text]="'Reject'" (submit)="action(false)"></core-helpers-forms-button>
  </div>

</div>
</article>
